var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.383,
    height: 24.587,
    viewBox: "0 0 24.383 24.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#f1964f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.012,6H5.225A2.225,2.225,0,0,0,3,8.225V23.8a2.225,2.225,0,0,0,2.225,2.225H20.8A2.225,2.225,0,0,0,23.023,23.8V16.012",
    transform: "translate(0 -0.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.68,3.509a2.36,2.36,0,1,1,3.337,3.337L16.45,17.414,12,18.527l1.112-4.45Z",
    transform: "translate(-2.326 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherEdit);
export default __webpack_public_path__ + "static/media/Icon-feather-edit.abc411f70b5e4f4050d2a3f6ed02af8d.svg";
export { ForwardRef as ReactComponent };